import script from "./ModalMensagemDorape.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalMensagemDorape.vue?vue&type=script&setup=true&lang=ts"

import "./ModalMensagemDorape.vue?vue&type=style&index=0&id=2987d4ef&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2987d4ef"]])

export default __exports__